import { render } from "./BaseAvatar.vue?vue&type=template&id=3096a550&ts=true"
import script from "./BaseAvatar.vue?vue&type=script&lang=ts"
export * from "./BaseAvatar.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__